module.exports = __webpack_public_path__ + "static/img/station04.0884ed9e.png";